import { useState } from 'react';

/**
 * T2-B Track 1 (2026-05-05) — 재료 thumb primitive.
 *   props 단일 영역 = `name` + `imageUrl` (= server side cascade 결과).
 *   client 영역 cascade 책임 0 — N2 (2026-05-08) — 옛 ingredient image-resolver 폐기, mirror photoUrl 직접 사용.
 *   가 imageUrl + imageSource 를 결정한 envelope 를 그대로 받아 사용.
 *
 *   회귀 0: current.tsx:868-912 인라인 정의 영역 그대로 추출. 픽셀 동일.
 *   props.size 추가 = low.tsx 영역 32px·48px 영역 영역 영역 영역 (default 40).
 */
export interface ItemThumbProps {
  name: string;
  imageUrl: string | null;
  size?: number;
}

export function ItemThumb({ name, imageUrl, size = 40 }: ItemThumbProps) {
  const [errored, setErrored] = useState(false);
  const initial = (name?.trim().charAt(0) || '?').toUpperCase();

  if (imageUrl && !errored) {
    return (
      <img
        src={imageUrl}
        alt={name}
        width={size}
        height={size}
        loading="lazy"
        onError={() => setErrored(true)}
        style={{
          width: size,
          height: size,
          borderRadius: 8,
          objectFit: 'cover',
          background: 'var(--bg-subtle)',
          border: '1px solid var(--border-weak)',
        }}
      />
    );
  }
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: 8,
        background: 'var(--bg-subtle)',
        border: '1px solid var(--border-weak)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: Math.round(size * 0.35),
        fontWeight: 700,
        color: 'var(--fg-3)',
      }}
    >
      {initial}
    </div>
  );
}
